import { useEffect } from 'react';

const useInitialize = (effect: React.EffectCallback) => {
  useEffect(() => {
    effect();
  }, []);
};

export default useInitialize;
